import React, { FunctionComponent, useState } from 'react'
import useIntl from '@/utils/intl'
import { ArrowForward, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { SocialLink, KeyValPair, Link as LinkType } from '@/services/cms-api/home-page-content/types'
import { useLanguage } from '@/context/LanguageContext'
import { useRouter } from 'next/navigation'
import MCButton from '../ui/Buttons/MobicomButton'
import DarkIconButton from '../ui/Buttons/SecondaryIconButton'
import Link from 'next/link'
import Image from 'next/image'
import { useContentContext } from '@/context/ContentContext'
import { resolveImageUrl } from '@/utils/constants'
import * as ga from '@/utils/ga'

const Footer: FunctionComponent = () => {
  const { translate } = useIntl()
  const { locale } = useLanguage()

  const [open, setOpen] = useState<number | undefined>()
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const { state: { homePageContent } } = useContentContext()

  const router = useRouter()

  const handleOpen = (i: number): void => {
    if (i === open) {
      setOpen(undefined)
    } else {
      setOpen(i)
    }
  }
  if (homePageContent?.footerBanners === undefined) {
    return <></>
  }
  const handleCall = (number: string): void => {
    if (window !== undefined) {
      window.open('tel:' + number)
    }
  }
  return (
    <div className='bg-surfaceLow flex justify-center items-center pt-10 pb-20'>
      <div className='rounded-xl w-[95vw] bg-secondaryAdditional lg:p-10 p-6'>
        <div className='flex xl:flex-row flex-col justify-between 2xl:gap-20 xl:gap-8'>
          <div className='hidden lg:flex justify-between w-full xl:pr-12'>
            <ul>
              <h1 className='font-bold text-lg text-textAdditional mb-6'>{translate('footer.aboutus')}</h1>
              {homePageContent?.footer.about_us?.map((item: LinkType, i: number) => (
                <li id={'aboutUs.' + item.id.toString()} key={i} onClick={() => { (item.link !== undefined && item.link !== null) && router.push(item.link) }} className='text-textLow text-sm mt-3 font-medium cursor-pointer hover:text-textAdditional'>{locale === 'en' ? item.nameEn : item.nameMn}</li>
              ))}
            </ul>
            <ul>
              <h1 className='font-bold text-lg text-textAdditional mb-6'>{translate('footer.support')}</h1>
              {homePageContent?.footer.help?.map((item: LinkType, i: number) => (
                <li id={'help.' + item.id.toString()} onClick={() => { if (item.link !== undefined && item.link !== null) { ga.event('footer_link_click', { label: item.nameEn }); router.push(item.link) } }} key={i} className='text-textLow text-sm mt-3 font-medium cursor-pointer hover:text-textAdditional'>{locale === 'en' ? item.nameEn : item.nameMn}</li>
              ))}
            </ul>
            <ul>
              <h1 className='font-bold text-lg text-textAdditional mb-6'>{translate('footer.contact')}</h1>
              {homePageContent?.footer.contact_us?.map((item: KeyValPair, i: number) => (
                <div key={i} className='mt-3'>
                  <li className='text-textLow text-sm font-medium'>{locale === 'en' ? item.keyEn : item.keyMn}</li>
                  <li className='text-textAdditional font-bold cursor-pointer text-sm' onClick={() => handleCall(locale === 'en' ? item.valueEn : item.valueMn)}>{locale === 'en' ? item.valueEn : item.valueMn}</li>
                </div>
              ))}
              <div className='mt-3'>
                <li className='text-textLow text-sm'>{translate('shop.address')}</li>
                <li className='text-textAdditional font-medium cursor-pointer w-52 text-sm'>{translate('address')}</li>
              </div>
            </ul>
          </div>
          <div className='lg:hidden flex flex-col gap-4'>
            <ul>
              <div className='flex justify-between w-full items-center cursor-pointer p-2 hover:bg-appBar2 rounded-xl' onClick={() => handleOpen(1)}>
                <h1 className='font-bold text-lg text-textAdditional'>{translate('footer.aboutus')}</h1>
                {
                  open === 1
                    ? <KeyboardArrowUp className='text-textAdditional' />
                    : <KeyboardArrowDown className='text-textAdditional' />

                }
              </div>
              {
                open === 1
                  ? (homePageContent?.footer.about_us.map((item: LinkType, i: number) => (
                    <li key={i} onClick={() => { (item.link !== undefined && item.link !== null) && router.push(item.link) }} className='text-textLow text-sm mt-1 p-2 hover:bg-appBar2 rounded-xl cursor-pointer'>{locale === 'en' ? item.nameEn : item.nameMn}</li>
                    )))
                  : <></>
              }
            </ul>
            <ul>
              <div className='flex justify-between w-full items-center cursor-pointer p-2 hover:bg-appBar2 rounded-xl' onClick={() => handleOpen(0)}>
                <h1 className='font-bold text-lg text-textAdditional'>{translate('footer.support')}</h1>
                {
                  open === 0
                    ? <KeyboardArrowUp className='text-textAdditional' />
                    : <KeyboardArrowDown className='text-textAdditional' />

                }
              </div>
              {
                open === 0
                  ? (homePageContent?.footer.help.map((item: LinkType, i: number) => (
                    <li key={i} onClick={() => { if (item.link !== undefined && item.link !== null) { ga.event('footer_link_click', { label: item.nameEn }); router.push(item.link) } }} className='text-textLow text-sm mt-1 p-2 hover:bg-appBar2 rounded-xl cursor-pointer'>{locale === 'en' ? item.nameEn : item.nameMn}</li>
                    )))
                  : <></>
              }
            </ul>

            <ul>
              <div className='flex justify-between w-full items-center cursor-pointer p-2 hover:bg-appBar2 rounded-xl' onClick={() => handleOpen(2)}>
                <h1 className='font-bold text-lg text-textAdditional'>{translate('footer.contact')}</h1>
                {
                  open === 2
                    ? <KeyboardArrowUp className='text-textAdditional' />
                    : <KeyboardArrowDown className='text-textAdditional' />

                }
              </div>
              {
                open === 2
                  ? (
                    <div>
                      {homePageContent?.footer.contact_us.map((item: KeyValPair, i: number) => (
                        <div key={i} className='mt-1 p-2'>
                          <li className='text-textLow text-sm'>{locale === 'en' ? item.keyEn : item.keyMn}</li>
                          <li className='text-textAdditional font-bold cursor-pointer' onClick={() => handleCall(locale === 'en' ? item.valueEn : item.valueMn)}>{locale === 'en' ? item.valueEn : item.valueMn}</li>
                        </div>
                      ))}
                      <div className='mt-1 p-2'>
                        <li className='text-textLow text-sm'>{translate('shop.address')}</li>
                        <li className='text-textAdditional font-bold cursor-pointer'>{translate('address')}</li>
                      </div>
                    </div>
                    )
                  : <></>
              }

            </ul>
          </div>
          <div className='h-full xl:mt-0 lg:mt-10 mt-6'>
            <div className='rounded-xl relative 2xl:w-[611px] xl:w-[437px] lg:h-[220px] h-[200px]'>
              <Image draggable={false} className='rounded-xl w-full h-full object-cover' width={1000} height={1000} src={resolveImageUrl(homePageContent.footerBanners[currentImageIndex].image)} alt='img' />
              <div className='bg-gradient-to-r w-full h-full from-black lg:py-10 py-8 px-6 rounded-xl absolute -translate-y-full'>
                <p className='text-textAdditional font-bold lg:text-2xl text-base mb-4 whitespace-pre-line'>{(locale === 'en' ? homePageContent.footerBanners[currentImageIndex].titleEn : homePageContent.footerBanners[currentImageIndex].titleMn).replaceAll('$', '\n')}</p>
                <Link href={homePageContent.footerBanners[currentImageIndex].link} rel='noopener noreferrer' target='_blank'>
                  <MCButton size='sm' trailingIcon={<ArrowForward />}>{locale === 'en' ? homePageContent.footerBanners[currentImageIndex].buttonTextEn : homePageContent.footerBanners[currentImageIndex].buttonTextMn}</MCButton>
                </Link>
              </div>
            </div>
            <div className='flex mt-4 gap-1 w-full justify-between items-center'>
              <div className='flex gap-2'>
                <DarkIconButton size='sm' type='onDark' iconImg={resolveImageUrl('/uploads/icons/chevron-left-white.svg')} onClick={() => setCurrentImageIndex(0)} />
                <DarkIconButton size='sm' type='onDark' iconImg={resolveImageUrl('/uploads/icons/chevron-right-white.svg')} onClick={() => setCurrentImageIndex(1)} />
              </div>
              <div className='flex gap-2'>
                <div onClick={() => setCurrentImageIndex(0)} className={'h-1 rounded-full cursor-pointer hover:bg-slate-300 ' + (currentImageIndex === 0 ? 'bg-white w-6' : ' w-1 bg-footermain2')} />
                <div onClick={() => setCurrentImageIndex(1)} className={'h-1 rounded-full cursor-pointer hover:bg-slate-300 ' + (currentImageIndex === 1 ? 'bg-white w-6' : ' w-1 bg-footermain2')} />
              </div>
            </div>
          </div>
        </div>
        <hr className='border-white/25 lg:my-10 my-4' />
        <div className='flex items-center justify-between lg:flex-row flex-col'>
          <div className='flex items-center'>
            <Image draggable={false} width={62} height={34} src={resolveImageUrl('/uploads/white_text.svg')} alt='logo' className='hidden lg:flex' />
            <span className='text-xs text-textLow lg:ml-10 font-semibold'>© 1996 - 2025 {translate('mobicom')}</span>
          </div>
          <div className='flex gap-2 mt-3'>
            {homePageContent?.footer.social_links?.map((item: SocialLink, i: number) => (
              <Link href={item.link} key={i} rel='noopener noreferrer' className='cursor-pointer'>
                <DarkIconButton type='onDark' roundedFull size='sm' iconImg={resolveImageUrl((item.image.url))} />
              </Link>
            ))}
          </div>

        </div>

      </div>
    </div>
  )
}
export default Footer
